/* eslint-disable @typescript-eslint/no-explicit-any */
import 'dayjs/locale/fr';
import {defaultErrorValues} from '../../data/constants/Assurance/AssuranceRapatriement/devis';
import {
  AGE_LIMIT_NO_GARANTI_RAPATRIEMENT,
  AGE_LIMIT_RAPATRIEMENT,
  AGE_MIN_RAPATRIEMENT,
  defaultErrorAssured,
  defaultSouscriptionRapatriementErrorValues,
} from '../../data/constants/Assurance/AssuranceRapatriement/souscription';
import {
  DevisRapatriementParam,
  IError,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {
  IAssured,
  IErrorRapatriement,
  IFormRapatriementDTO,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/souscription';
import {
  MAIL_VALIDATION,
  MESSAGE_VALIDATION,
  TELEPHONE_VALIDATION,
} from './validation';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {defaultModificationRapatriementError} from '../../data/constants/Assurance/AssuranceRapatriement/modification';
import {defaultErrorValues as defaultResiliationErrorValues} from '../../data/constants/Assurance/AssuranceRapatriement/resiliation';
import {
  ModificationRapatriementDTO,
  ModificationRapatriementError,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/modification';
import {IError as IResiliationError} from '../../data/types/interface/Assurance/AssuranceRapatriement/resiliation';

dayjs.extend(customParseFormat);
// {dateNaissance: '', paysResidence: ''}[] soit '' soit message d'erreur
export const validateDevisRapatriement = (values: DevisRapatriementParam[]) => {
  const errors: DevisRapatriementParam[] = [];
  values.forEach((v, index) => {
    errors[index] = {
      paysResidence: '',
      dateNaissance: '',
    };
    if (v.dateNaissance == '') {
      errors[index].dateNaissance = MESSAGE_VALIDATION.requiredField;
    } else if (
      !dayjs(v.dateNaissance).isValid() ||
      dayjs(v.dateNaissance, 'YYYY-MM-DD').isAfter(dayjs(), 'day')
    ) {
      errors[index].dateNaissance = MESSAGE_VALIDATION.invalidDate;
    } else {
      const age = dayjs().diff(dayjs(v.dateNaissance), 'year');
      if (age < AGE_MIN_RAPATRIEMENT) {
        errors[
          index
        ].dateNaissance = `L'âge minimum de l'ajout de bénéficiaire est de ${AGE_MIN_RAPATRIEMENT} ans`;
      } else if (age > AGE_LIMIT_RAPATRIEMENT) {
        errors[
          index
        ].dateNaissance = `L'âge limite du nouveau bénéficiaire pour la première souscription est de ${AGE_LIMIT_RAPATRIEMENT} ans`;
      }
    }
    if (v.paysResidence.trim() == '') {
      errors[index].paysResidence = MESSAGE_VALIDATION.requiredField;
    } else if (v.paysResidence.trim().toLowerCase() == 'madagascar') {
      errors[index].paysResidence = MESSAGE_VALIDATION.notInMadagascar;
    }
  });
  return errors;
};

export const ValidationDevis = (values: IError) => {
  let errors: IError = {...defaultErrorValues};

  if (!values.listNaissance.length) {
    errors.listNaissance =
      'Veuillez inserer les dates de naissances des personnes assurées.';
  }

  const propertyException: Array<string> = [];

  /** checking all required values */
  Object.entries(values).forEach(element => {
    if (
      (element[1] === '' ||
        element[1] === null ||
        element[1] === 'INVALID INPUT' ||
        (Array.isArray(element[1]) && element[1].length === 0)) &&
      !propertyException.includes(element[0])
    ) {
      if (element[0] !== 'type') {
        errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
      }
    }
  });

  return errors;
};

export const ValidationSouscription = (values: IFormRapatriementDTO) => {
  let errors: IErrorRapatriement = {
    ...defaultSouscriptionRapatriementErrorValues,
  };

  if (values.assure.length) {
    errors.assure = [
      ...values.assure.map((element: any) => ({
        ...defaultErrorAssured,
        id: element.id,
      })),
    ];
  }

  if (dayjs(values.dateDebut).isBefore(dayjs(), 'day')) {
    errors.dateDebut = `La date de début du contrat doit être supérieure à aujourd'hui`;
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[0] !== 'assure' && (element[1] === '' || element[1] === null)) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    } else if (element[0] === 'assure') {
      element[1].map((assureElt: IAssured, index: number) => {
        /** check numero de carte d'identité */
        if (!/^[A-Za-z0-9]{6,15}$/.test(assureElt.numCI)) {
          errors.assure[index].numCI = MESSAGE_VALIDATION.invalidCIN;
        }
        /** check nom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.nom)) {
          errors.assure[index].nom = MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }
        /** check prenom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.prenom)) {
          errors.assure[index].prenom =
            MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }
        /** check email */
        if (!MAIL_VALIDATION.test(assureElt.email)) {
          errors.assure[index].email = MESSAGE_VALIDATION.requiredEmail;
        }
        /** check sexe */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.sexe)) {
          errors.assure[index].sexe = MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }
        /** check adresse */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.adressePostale)) {
          errors.assure[index].adressePostale =
            MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }

        // check dateNaissance
        const age = dayjs().diff(dayjs(assureElt.dateNaissance), 'year');

        if (age < AGE_MIN_RAPATRIEMENT) {
          errors.assure[
            index
          ].dateNaissance = `L'âge minimum de l'ajout de bénéficiaire est de ${AGE_MIN_RAPATRIEMENT} ans`;
        } else {
          if (assureElt.isNew && age > AGE_LIMIT_RAPATRIEMENT) {
            errors.assure[
              index
            ].dateNaissance = `L'âge limite du nouveau bénéficiaire pour la première souscription est de ${AGE_LIMIT_RAPATRIEMENT} ans`;
          }
          if (age > AGE_LIMIT_NO_GARANTI_RAPATRIEMENT) {
            errors.assure[
              index
            ].dateNaissance = `Les garanties cessent aux ${AGE_LIMIT_RAPATRIEMENT} ans révolus de l'assuré `;
          }
        }

        /** check pays de résidence */
        if (/^madagascar$/i.test(assureElt.paysResidence)) {
          errors.assure[index].paysResidence =
            MESSAGE_VALIDATION.notInMadagascar;
        }

        /** check phone number */
        if (!TELEPHONE_VALIDATION.test(assureElt.telephone)) {
          errors.assure[index].telephone = MESSAGE_VALIDATION.requiredTelephone;
        }

        /** check countryCode */
        if (assureElt.countryCode == 'MG') {
          errors.assure[index].telephone =
            MESSAGE_VALIDATION.phonenotInMadagascar;
        }

        const elementPropertyException = [
          'menu',
          'lastCaptureFile',
          'newImage',
          'socketId',
          'isEditable',
          'isNew',
        ];
        Object.entries(assureElt).forEach(elementProperty => {
          if (
            (elementProperty[1] === '' ||
              elementProperty[1] === null ||
              elementProperty[1] === undefined ||
              (elementProperty[0] === 'capture_file' &&
                Array.isArray(elementProperty[1]) &&
                !elementProperty[1].length)) &&
            !elementPropertyException.includes(elementProperty[0])
          ) {
            errors.assure[index] = {
              ...errors.assure[index],
              [elementProperty[0]]: MESSAGE_VALIDATION.requiredField,
            };
          }
        });
      });
    }
  });

  return errors;
};

export const ValidationResiliation = (values: IError) => {
  let errors: IResiliationError = {...defaultResiliationErrorValues};

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[1] === '' || element[1] === null) {
      errors = {...errors, [element[0]]: 'Ce champ est obligatoire'};
    }
  });

  return errors;
};

export const ValidationModification = (values: ModificationRapatriementDTO) => {
  const errors: ModificationRapatriementError = {
    ...defaultModificationRapatriementError,
  };

  if (!values.dateDebut) {
    errors.dateDebut = MESSAGE_VALIDATION.requiredField;
  } else {
    if (dayjs(values.dateDebut).isBefore(dayjs())) {
      errors.dateDebut = `La date de début du contrat doit être supérieure à aujourd'hui`;
    }
  }

  return errors;
};
